import { IconLayer } from '@deck.gl/layers';

import { MapMarkerLayer } from '../../types';

import coommonLayerSettings from '../utils/commonLayerSettings';

const markerLayerCreator = ({
  name = 'marker-icon',
  ...otherProps
// @ts-ignore
}: MapMarkerLayer) => new IconLayer({
  ...coommonLayerSettings,
  id: name,
  ...otherProps
});

export default markerLayerCreator;
